// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Type_Image = require("../type/Type_Image.bs.js");
var Util_Array = require("./Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Particle_Css = require("../design-system/particle/Particle_Css.bs.js");
var Particle_Screen_Ds = require("../design-system/particle/Particle_Screen_Ds.bs.js");

function createIdentifierSelector(attributes) {
  return Belt_Array.map(attributes, (function (identifier) {
                  return "[data-testid='" + identifier + "']";
                })).join(", ");
}

function toRules(toCssRule, value) {
  return Util_Array.pure(Curry._1(toCssRule, value));
}

var ieMediaQuery = "all and (-ms-high-contrast: none), (-ms-high-contrast: active)";

function ieRules(param) {
  return CssJs.media(ieMediaQuery, param);
}

function makeChildClass(childRules) {
  return Belt_Option.mapU(Belt_Option.map(Belt_Option.map(childRules, (function (param) {
                        return CssJs.selector("> *", param);
                      })), Util_Array.pure), CssJs.style);
}

function preserveAspectRatioRules(ratio) {
  var match = Type_Image.Ratio.getDimensions(Type_Image.Ratio.make(ratio));
  if (match !== undefined) {
    return [CssJs.before([
                  CssJs.display("block"),
                  CssJs.unsafe("content", ""),
                  CssJs.width(CssJs.px(1)),
                  CssJs.marginLeft(CssJs.px(-1)),
                  CssJs.$$float("left"),
                  CssJs.height(CssJs.px(0)),
                  CssJs.paddingTop(CssJs.pct(match.height / match.width * 100))
                ])];
  } else {
    return [];
  }
}

function gapPolyfill(gap) {
  return [
          CssJs.margin({
                NAME: "pxFloat",
                VAL: gap / -2
              }),
          CssJs.children([CssJs.margin({
                      NAME: "pxFloat",
                      VAL: gap / 2
                    })])
        ];
}

function calcTextLineSize(lineHeight, size) {
  return Particle_Screen_Ds.map((function (fontSize) {
                var lineHeightCoeff = Particle_Css.line_height_float(lineHeight);
                var fontSizeValue = Particle_Css.font_size_int(fontSize);
                return CssJs.px(lineHeightCoeff * fontSizeValue | 0);
              }), size);
}

exports.createIdentifierSelector = createIdentifierSelector;
exports.toRules = toRules;
exports.ieMediaQuery = ieMediaQuery;
exports.ieRules = ieRules;
exports.makeChildClass = makeChildClass;
exports.preserveAspectRatioRules = preserveAspectRatioRules;
exports.gapPolyfill = gapPolyfill;
exports.calcTextLineSize = calcTextLineSize;
/* CssJs Not a pure module */
